class UIManager {
    constructor() {
        this.html = document.querySelector("html");
        this.toggleThemeButton = document.querySelector("#toggle-theme");
        this.toggleThemeIcon = this.toggleThemeButton?.querySelector("i");

        this.toggleMenuButton = document.querySelector("#toggle-menu");
        this.mobileMenu = document.querySelector("#mobile-menu-2");
        this.dropdowns = document.querySelectorAll(".dropdown");
    }

    init() {

        this.initTheme();
        this.initMenu();
        this.initDropdowns();
        this.initClickOutsideMenu();
    }

    initTheme() {
        if (!this.toggleThemeButton) {
            return;
        }

        this.setInitialTheme();

        this.toggleThemeButton.addEventListener('click', () => {
            this.toggleTheme();
        });
    }

    toggleTheme() {

        let isDark = this.html.classList.contains('dark');

        if (isDark) {
            this.html.classList.remove('dark');
            localStorage.theme = 'light';
            document.body.setAttribute("data-layout-mode", "light");
            this.toggleThemeIcon.className = "ti ti-moon top-icon text-[#f1f9ffa1]";
        } else {
            this.html.classList.add('dark');
            localStorage.theme = 'dark';
            document.body.setAttribute("data-layout-mode", "dark");
            this.toggleThemeIcon.className = "ti ti-sun top-icon dark:text-[#d39e03] dark:hover:text-[#d3ab03]";
        }
    }

    setInitialTheme() {
        console.log('ThemeManager.setInitialTheme() called');

        if (localStorage.theme === 'dark' || (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
            this.html.classList.add('dark');
            this.toggleThemeIcon.className = "ti ti-sun top-icon dark:text-[#d39e03] dark:hover:text-[#d3ab03]";
        } else {
            this.html.classList.remove('dark');
            this.toggleThemeIcon.className = "ti ti-moon top-icon text-[#f1f9ffa1]";
        }
    }

    initMenu() {
        if (!this.toggleMenuButton) {
            return;
        }

        this.toggleMenuButton.addEventListener('click', () => {
            this.toggleMenu();
        });
    }

    toggleMenu() {
        this.mobileMenu.classList.toggle("block");
        if (this.mobileMenu.classList.contains('block')) {
            this.mobileMenu.classList.remove("hidden");
        } else {
            this.mobileMenu.classList.add("hidden");
        }
    }

    initDropdowns() {

        if (this.dropdowns.length === 0) {
            return; 
        }

        this.dropdowns.forEach((dropdown) => {
            const toggle = dropdown.querySelector(".dropdown-toggle");
            const menu = dropdown.querySelector(".dropdown-menu");
            toggle.addEventListener("click", (event) => {
                this.handleDropdownToggle(toggle, menu, event);
            });
        });
    }

    handleDropdownToggle(toggle, menu, event) {
        toggle.classList.toggle("block");
        if (!toggle.classList.contains("block")) {
            menu.classList.remove("block");
            menu.classList.add("hidden");
        } else {
            this.dismissDropdownMenu(); 
            menu.classList.add("block");
            menu.classList.remove("hidden");
            if (menu.classList.contains("block")) {
                toggle.classList.add("block");
            } else {
                toggle.classList.remove("block");
            }
        }
        event.stopPropagation();
    }

    dismissDropdownMenu() {
        document.querySelectorAll(".dropdown-menu").forEach((menu) => {
            menu.classList.remove("block");
            menu.classList.add("hidden");
        });
        document.querySelectorAll(".dropdown-toggle").forEach((toggle) => {
            toggle.classList.remove("block");
        });
    }

    initClickOutsideMenu() {
        window.addEventListener('click', (e) => {
            this.dismissDropdownMenu();
        });
    }
}

export default UIManager;